/*
 * Панель источника (SourcePanel.tsx). Дети карточки диалога не сжимаются — `Modal.module.css`
 * держит `.card > * { flex-shrink: 0 }`, поэтому своих высот здесь нет: прокручивается
 * карточка. На 390px всё переносится строками, а длинные адреса и причины из реестра рвутся
 * где угодно (`overflow-wrap: anywhere`) — иначе они уводили бы карточку вбок.
 */

.head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.home {
  font-size: 13px;
  overflow-wrap: anywhere;
}

.field {
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  min-width: 0;
}

.range {
  flex: 1 1 200px;
  min-width: 0;
  accent-color: var(--violet);
}

.value {
  min-width: 3.5em;
  font-size: 20px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: var(--ink);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.note {
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.health {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  min-width: 0;
}
